module.exports = __webpack_public_path__ + "img/iuv-default.eca149bd.png";